var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 7.5,
    fill: "white",
    stroke: "#E4EAF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2314_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1353 9.80559C17.613 9.80352 17.9999 9.41145 17.9999 8.92791V7.87768C17.9999 7.39413 17.609 7 17.1293 7H7.87059C7.391 7 7 7.39413 7 7.87768V8.93006C7 9.41155 7.38691 9.80362 7.86455 9.80774C7.99761 11.376 8.88037 12.7494 10.2186 13.501C8.88035 14.2527 7.9976 15.6281 7.86455 17.1943C7.38691 17.1983 7 17.5905 7 18.072V19.1223C7 19.6058 7.39099 20 7.87069 20H17.1294C17.609 20 18 19.6058 18 19.1223L17.9999 18.072C17.9999 17.5905 17.613 17.1984 17.1353 17.1943C17.0023 15.626 16.1196 14.2526 14.7813 13.501C16.1196 12.7473 17.0023 11.374 17.1353 9.80559ZM7.80593 8.92997V7.87768C7.80593 7.84111 7.83414 7.81268 7.87042 7.81268H17.1291C17.1653 7.81268 17.1935 7.84111 17.1935 7.87768V8.93006C17.1935 8.96663 17.1653 8.99506 17.1291 8.99506L7.87042 8.99497C7.83414 8.99497 7.80593 8.96458 7.80593 8.92997ZM17.1938 18.0721V19.1224C17.1938 19.159 17.1656 19.1874 17.1293 19.1874H7.87043C7.83415 19.1874 7.80594 19.159 7.80594 19.1224V18.0721C7.80594 18.0355 7.83415 18.0071 7.87043 18.0071H17.1291C17.1655 18.0071 17.1938 18.0375 17.1938 18.0721ZM13.6406 13.1129C13.4713 13.1658 13.3564 13.3221 13.3564 13.501C13.3564 13.6797 13.4713 13.8362 13.6406 13.889C15.134 14.3542 16.1759 15.6545 16.3332 17.1944H8.6646C8.82177 15.6545 9.86374 14.3542 11.3591 13.889C11.5285 13.8362 11.6433 13.6798 11.6433 13.501C11.6433 13.3222 11.5285 13.1658 11.3591 13.1129C9.86576 12.6477 8.82375 11.3475 8.6665 9.8075H16.3351C16.1759 11.3454 15.134 12.6455 13.6406 13.1129Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2314_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 13,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3f3defb7f62274b3b1ca150b225538df.svg";
export { ForwardRef as ReactComponent };